import React, {FC, memo, ReactNode} from 'react';
import styled from 'styled-components';
import Skeleton from '@material-ui/lab/Skeleton';
import {getDirectionStyles} from '../../utils/ThemeUtils';

const Container = styled.div`
    padding: ${p => p.theme.muiTheme.spacing(0, 4)};

    & span {
        border-radius: ${p => p.theme.muiTheme.shape.borderRadius}px;
    }

    & > div {
        display: flex;
        align-items: center;
        height: 40px;

        & > span:first-of-type {
            margin: ${p =>
                getDirectionStyles(p.theme.muiTheme.direction)(
                    p.theme.muiTheme.spacing(0, 4, 0, 0),
                    p.theme.muiTheme.spacing(0, 0, 0, 4)
                )};
        }
    }
`;

export interface ListSkeletonProps {
    itemsCount?: number;
    children?: ReactNode;
}

const ListSkeleton: FC<ListSkeletonProps> = memo<ListSkeletonProps>(
    ({itemsCount = 10, children}: ListSkeletonProps) => {
        const items = new Array(itemsCount).fill(null).map(() => Math.random().toString(36));

        return (
            <Container>
                {children}
                {items.map(key => (
                    <div key={key}>
                        <Skeleton width={22} height={20} variant="rect" />
                        <Skeleton width="100%" height={15} variant="rect" />
                    </div>
                ))}
            </Container>
        );
    }
);

export default ListSkeleton;
